import { Helmet } from 'react-helmet';
import './Home.css';
import { useMediaQuery } from '@mui/material';
import SeoSection from '../components/SeoSection';
import SocialBanner from "../components/SocialBanner";

const Home = (props) => {
    const matches = useMediaQuery('(max-width:550px)');
    let iframeHeight = 2000 + "px";
    if (matches) {
        iframeHeight = window.innerHeight + "px";
    }

    const socialButtons = [
        {icon: 'instagram', link: '/instagram', title: 'instagram'},
        {icon: 'facebook', link: '/facebook', title: 'facebook'},
    ]

    return (
        <>
            <Helmet>
                <title>Risultati in diretta di Calcio - Livescore | BetFlagLive</title>
                <meta name="description" content="Segui i risultati in diretta di calcio su BetFlagLive. Rimani sempre aggiornato sui punteggi e le partite in corso grazie al nostro livescore affidabile e preciso."/>
            </Helmet>
            <SocialBanner socialButtons={socialButtons}></SocialBanner>
            <iframe title="Livescore" src="https://statshub.sportradar.com/betflag/it" width="100%" height={iframeHeight} marginHeight={0} marginWidth={0} />
            
            <SeoSection page={'home'} />
        </>
    )
}

Home.currentPage = "home";

export default Home;